var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"parent",class:[_vm.bgClass, _vm.textClass, _vm.alignClass, _vm.pClass]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }